import { __read } from "tslib";
/* eslint-disable complexity */
import * as ua from '@tencent/docs-user-agent/pure';
import { getFileTypeForReport } from './filetype';
/**
 * @author chocofeng
 * @see https://doc.weixin.qq.com/sheet/e3_m_APVxKJPLfFdk?tab=ysid9k
 * @file 新的 aid 生成规则：
 *  标准：固定前缀为 txdocs，aid所有都为小写，txdocs_系统_平台_位置_功能_增值点1_增值点2_增值点3
 *  3 个增值点可为空，其余参数不可为空
 */
var systemCache;
var platformCache;
var SYSTEMS;
(function (SYSTEMS) {
    SYSTEMS["AN"] = "an";
    SYSTEMS["IOS"] = "ios";
    SYSTEMS["MAC"] = "mac";
    SYSTEMS["WD"] = "wd";
    SYSTEMS["HMOS"] = "hmos";
    SYSTEMS["UNKNOWN"] = "";
})(SYSTEMS || (SYSTEMS = {}));
var PLATFORMS;
(function (PLATFORMS) {
    PLATFORMS["WXSP"] = "wxsp";
    PLATFORMS["QQSP"] = "qqsp";
    PLATFORMS["QQSJB"] = "qqsjb";
    PLATFORMS["QQDK"] = "qqdk";
    PLATFORMS["QQJL"] = "qqjl";
    PLATFORMS["DESK"] = "desk";
    PLATFORMS["H5"] = "h5";
    PLATFORMS["QBH5"] = "qbh5";
    PLATFORMS["WEB"] = "web";
    PLATFORMS["APP"] = "app";
    PLATFORMS["QQMini"] = "qqmini";
    PLATFORMS["UNKNOWN"] = "";
})(PLATFORMS || (PLATFORMS = {}));
export var AID_PREFIX;
(function (AID_PREFIX) {
    AID_PREFIX["DOCS"] = "txdocs";
    AID_PREFIX["CLOUD"] = "txcloud";
    AID_PREFIX["LOCAL"] = "txlocal";
    AID_PREFIX["APPOP"] = "txappop";
    AID_PREFIX["DEFAULT"] = "default";
})(AID_PREFIX || (AID_PREFIX = {}));
function mapsMatch(maps, deftValue) {
    for (var i = 0; i < maps.length; i++) {
        var _a = __read(maps[i], 2), func = _a[0], value = _a[1];
        if ((typeof func === 'function' && func()) || func) {
            return value;
        }
    }
    return deftValue;
}
export function getQuery(key) {
    var m = null;
    var location = window.location;
    if (location) {
        m = location.search.match(new RegExp("(\\?|&)" + key + "=([^&]*)(#|&|$)"));
    }
    return !m ? '' : decodeURIComponent(m[2]);
}
function getSystem() {
    var systemMaps = [
        [ua.isAndroid(), SYSTEMS.AN],
        [ua.isIOS(), SYSTEMS.IOS],
        [ua.isWindows(), SYSTEMS.WD],
        [ua.isMac(), SYSTEMS.MAC],
        [ua.isHarmony(), SYSTEMS.HMOS],
    ];
    return mapsMatch(systemMaps, AID_PREFIX.DEFAULT);
}
function getPlatform() {
    var systemMaps = [
        [ua.isQQDesktopDocsClient(), PLATFORMS.QQMini],
        [ua.isMobileQQBrowser(), PLATFORMS.QBH5],
        [ua.isWxMiniProgram(), PLATFORMS.WXSP],
        [ua.isQQMiniProgram() && getQuery('qqapp') === 'form', PLATFORMS.QQSJB],
        [ua.isQQMiniProgram() && getQuery('qqapp') === 'clock', PLATFORMS.QQDK],
        [ua.isQQMiniProgram() && getQuery('qqapp') === 'jielong', PLATFORMS.QQJL],
        [ua.isQQMiniProgram(), PLATFORMS.QQSP],
        [ua.isMacAppStoreTencentDocsClient(), PLATFORMS.APP],
        [ua.isPCTencentDocsClient() || ua.isElectronTencentDocsClient(), PLATFORMS.DESK],
        [ua.isTencentDocsApp(), PLATFORMS.APP],
        [ua.isMobile(), PLATFORMS.H5],
        [ua.isPC(), PLATFORMS.WEB],
    ];
    return mapsMatch(systemMaps, AID_PREFIX.DEFAULT);
}
export function joinApprecString(apprecArray) {
    var _a = __read(apprecArray, 4), apprec1 = _a[0], apprec2 = _a[1], apprec3 = _a[2], apprec4 = _a[3];
    apprec4 = getFileTypeForReport() || apprec4;
    if (!apprec1 && (apprec2 || apprec3 || apprec4)) {
        apprec1 = 'null';
    }
    if (!apprec2 && (apprec3 || apprec4)) {
        apprec2 = 'null';
    }
    if (!apprec3 && apprec4) {
        apprec3 = 'null';
    }
    var apprecString = [apprec1, apprec2, apprec3, apprec4].filter(function (apprec) { return !!apprec; }).join('_');
    apprecString = apprecString ? "_" + apprecString : '';
    return apprecString;
}
export var POSITIONS;
(function (POSITIONS) {
    POSITIONS["APPSREC"] = "appsrec";
    POSITIONS["CAPSULE"] = "capsule";
    POSITIONS["CATALOGUE"] = "catalogue";
    POSITIONS["CLOUDPLAY"] = "cloudplay";
    POSITIONS["FILTERPANEL"] = "filterpanel";
    POSITIONS["HOMEPAGE"] = "homepage";
    POSITIONS["MORESETTING"] = "moresetting";
    POSITIONS["MYTAB"] = "mytab";
    POSITIONS["NOTIFY"] = "notify";
    POSITIONS["OPERATE"] = "operate";
    POSITIONS["PAYPAGE"] = "paypage";
    POSITIONS["PERSNLPANEL"] = "persnlpanel";
    POSITIONS["PUSH"] = "push";
    POSITIONS["TITLEBAR"] = "titlebar";
    POSITIONS["TOOLBAR"] = "toolbar";
    POSITIONS["WXGZH"] = "wxgzh";
    POSITIONS["UPLOAD"] = "upload";
    POSITIONS["IMPORT"] = "import";
    POSITIONS["TIPS"] = "tips";
    POSITIONS["TYPEFACE"] = "typeface";
    POSITIONS["ACTIVITY"] = "activity";
    POSITIONS["DETAIL"] = "detail";
    POSITIONS["LIST"] = "list";
    POSITIONS["SPACE"] = "space";
    POSITIONS["LEFUPCOR"] = "lefupcor";
    POSITIONS["LISTRIGCLK"] = "listrigclk";
    POSITIONS["LISTRIGUPCOR"] = "listrigupcor";
    POSITIONS["LISTSHARERECEIVE"] = "listsharereceive";
    POSITIONS["DRIVEDETAILRIGUPCOR"] = "drivedetailrigupcor";
    POSITIONS["DRIVEDETAIL"] = "drivedetail";
    POSITIONS["FOLDERLIST"] = "folderlist";
    POSITIONS["QQNOTICE"] = "qqnotice";
    POSITIONS["COLLECTATM"] = "collectatm";
    POSITIONS["TEMPLATEMALL"] = "templatemall";
    POSITIONS["SIDEBAR"] = "sidebar";
    POSITIONS["FORMCOUNT"] = "formcount";
    POSITIONS["COMMON"] = "common";
    POSITIONS["HOVER"] = "hover";
    POSITIONS["QQLOCALBAR"] = "qqlocalbar";
    POSITIONS["TBSLOCALBAR"] = "tbslocalbar";
    POSITIONS["DEFAULT"] = "default";
    POSITIONS["RIGLOWCOR"] = "riglowcor";
    POSITIONS["CHAT"] = "chat";
    POSITIONS["VIP_CENTER"] = "vipcenter";
    POSITIONS["DETAILRIGUPCOR"] = "detailrigupcor";
    POSITIONS["COMMENT"] = "comment";
    POSITIONS["ACCMANAGE"] = "accmanage";
    POSITIONS["SHARE"] = "share";
    POSITIONS["SHAREPANEL"] = "sharepanel";
    POSITIONS["MTGSHAREDLIST"] = "mtgsharedlist";
    POSITIONS["NAMEPLATE"] = "nameplate";
    POSITIONS["CHATNEWS"] = "chatnews";
    POSITIONS["EDITFORM"] = "editform";
    POSITIONS["SIDEBARTHUM"] = "sidebarthum";
    POSITIONS["RIGHTMENU"] = "rightmenu";
    POSITIONS["APPTOOLPANEL"] = "apptoolpanel";
    POSITIONS["PICTOOLBAR"] = "pictoolbar";
    POSITIONS["PICRIGHTMENU"] = "picrightmenu";
    POSITIONS["PICPREVIEW"] = "picpreview";
    POSITIONS["LEFUPCORNEW"] = "lefupcornew";
    POSITIONS["LEFUPCORIMPORT"] = "lefupcorimport";
    POSITIONS["DETAILNEW"] = "detailnew";
    POSITIONS["DRAG"] = "drag";
    POSITIONS["VIPCENAVATAR"] = "vipcenavatar";
    POSITIONS["CONVERSION"] = "conversion";
    POSITIONS["UNKNOWN"] = "";
})(POSITIONS || (POSITIONS = {}));
/**
 * 清除 systemCache 和 platformCache 变量，方便测试
 */
export function clearCache() {
    systemCache = null;
    platformCache = null;
}
/**
 * 生成 aid 的函数，必要的参数为触发位置和功能，系统和平台默认添加
 */
export function getAidForReport(aidOptions) {
    systemCache = systemCache !== null && systemCache !== void 0 ? systemCache : getSystem();
    platformCache = platformCache !== null && platformCache !== void 0 ? platformCache : getPlatform();
    var position = aidOptions.position, feature = aidOptions.feature, apprec1 = aidOptions.apprec1, apprec2 = aidOptions.apprec2, apprec3 = aidOptions.apprec3, apprec4 = aidOptions.apprec4;
    if (!verifyAidOptions(aidOptions)) {
        console.error('aid options 参数值校验失败，拒绝生成aid');
        return '';
    }
    var apprecString = joinApprecString([apprec1, apprec2, apprec3, apprec4]);
    var prefix = aidOptions.prefix ? aidOptions.prefix : getPrefix(); // 优先使用传入的prefix，否则自动生成prefix
    return prefix + "_" + systemCache + "_" + platformCache + "_" + position + "_" + feature + apprecString;
}
function getPrefix() {
    var _a, _b, _c, _d, _e;
    var result = AID_PREFIX.DOCS; // 默认 普通在线文档
    var pathName = '';
    var hostName = '';
    try {
        pathName = ((_b = (_a = window.top) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.pathname) || '';
        hostName = ((_d = (_c = window.top) === null || _c === void 0 ? void 0 : _c.location) === null || _d === void 0 ? void 0 : _d.hostname) || '';
    }
    catch (error) {
        console.error('window.top?.location error :', error);
        pathName = '';
        hostName = '';
    }
    if (pathName.length === 0 && hostName.length === 0) {
        try {
            var referrerStr = window.document.referrer;
            var url = new URL(referrerStr);
            pathName = url.pathname;
            hostName = url.host;
        }
        catch (error) {
            console.error('window.document.referrer error :', error);
            pathName = '';
            hostName = '';
        }
    }
    if (pathName.length === 0 && hostName.length === 0) {
        return result;
    }
    if (hostName !== 'docs.qq.com') {
        return result;
    }
    try {
        if (pathName && pathName.length > 0 && pathName.indexOf('/local_edit') !== -1) {
            // 本地文档
            result = AID_PREFIX.LOCAL;
        }
        else if (isTxCloud(pathName)) {
            // 云文档
            result = AID_PREFIX.CLOUD;
        }
        else if (!((_e = window.top) === null || _e === void 0 ? void 0 : _e.basicClientVars)) {
            // 离线包文档
            result = AID_PREFIX.APPOP;
        }
    }
    catch (error) {
        console.log('离线包文档 basicClientVars error:', error);
    }
    return result;
}
function isTxCloud(pathName) {
    var _a, _b, _c, _d;
    var result = false;
    try {
        // 链接带 `/document` 或者 `/pdf` 或者是 cosInfo?.driveExt 有值
        result =
            (pathName && pathName.length > 0 && (pathName.indexOf('/document') !== -1 || pathName.indexOf('/pdf') !== -1)) ||
                !!((_d = (_c = (_b = (_a = window.top) === null || _a === void 0 ? void 0 : _a.basicClientVars) === null || _b === void 0 ? void 0 : _b.docInfo) === null || _c === void 0 ? void 0 : _c.cosInfo) === null || _d === void 0 ? void 0 : _d.driveExt);
    }
    catch (error) {
        console.log('isTxCloud error:', error);
    }
    return result;
}
/**
 * 解析getAidForReport生成的aid，格式不对或解析失败返回undefined
 * @param aid
 * @returns
 */
// eslint-disable-next-line complexity
export var decomposeAid = function (aid) {
    var aidDecomposed = {
        prefix: AID_PREFIX.DEFAULT,
        system: SYSTEMS.UNKNOWN,
        plat: PLATFORMS.UNKNOWN,
        position: POSITIONS.UNKNOWN,
        feature: '',
        apprec1: undefined,
        apprec2: undefined,
        apprec3: undefined,
        apprec4: undefined,
    };
    try {
        var aidArr = aid.split('_');
        // 判断格式
        if (!aidArr.length || aidArr.length < 5) {
            return undefined;
        }
        aidDecomposed.prefix = aidArr[0];
        aidDecomposed.system = aidArr[1];
        aidDecomposed.plat = aidArr[2];
        aidDecomposed.position = aidArr[3];
        aidDecomposed.feature = aidArr[4];
        // 增值点
        if (aidArr[5] && aidArr[5] !== 'null') {
            aidDecomposed.apprec1 = aidArr[5];
        }
        if (aidArr[6] && aidArr[6] !== 'null') {
            aidDecomposed.apprec2 = aidArr[6];
        }
        if (aidArr[7] && aidArr[7] !== 'null') {
            aidDecomposed.apprec3 = aidArr[7];
        }
        if (aidArr[8] && aidArr[8] !== 'null') {
            aidDecomposed.apprec4 = aidArr[8];
        }
        return aidDecomposed;
    }
    catch (e) {
        return undefined;
    }
};
/**
 * 校验 aid options 参数
 * 校验不通过 console.error 出来对应错误提示，且返回false
 *
 * 现在需要校验的逻辑比较少，后续增多可以考虑用策略模式等
 * @param aidOptions
 */
export function verifyAidOptions(aidOptions) {
    // 开放position，不做position的校验
    // /**
    //  * 校验position
    //  * 1. 不为空
    //  * 2. 在 enum POSITIONS 里
    //  */
    // let find = false;
    // Object.keys(CommonPositions).forEach((key) => {
    //   const value = CommonPositions[key];
    //   if (value === aidOptions.position) {
    //     find = true;
    //   }
    // });
    // if (!aidOptions.position || !find) {
    //   console.error(
    //     'aidOptions.position 应为 enum POSITIONS: ',
    //     CommonPositions,
    //     '且不为空，却收到：',
    //     aidOptions.position,
    //   );
    //   return false;
    // }
    /**
     * 所有参数值若不是undefined 则为string 且不应该带有下划线
     * 这里就不单独校验 position 和 feature 为undefined的情况，因为ts就可以check了
     */
    var hasStringError = false;
    Object.entries(aidOptions).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (typeof value === 'undefined') {
            return;
        }
        if (typeof value !== 'string') {
            console.error("aidOptions." + key + " \u5E94\u4E3A string \u7C7B\u578B \u5374\u6536\u5230\uFF1A" + typeof value);
            hasStringError = true;
            return;
        }
        if (value.includes('_')) {
            console.error("aidOptions." + key + " \u7684\u503C\uFF1A" + value + "\u4E0D\u5E94\u8BE5\u5E26\u6709\u4E0B\u5212\u7EBF");
            hasStringError = true;
        }
    });
    if (hasStringError) {
        return false;
    }
    return true;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
export var POSITIONS_WEIYUN;
(function (POSITIONS_WEIYUN) {
    POSITIONS_WEIYUN["LIST"] = "list";
    POSITIONS_WEIYUN["RECENT"] = "recent";
    POSITIONS_WEIYUN["DOCUMENT"] = "document";
    POSITIONS_WEIYUN["PHOTO"] = "photo";
    POSITIONS_WEIYUN["UNKNOWN"] = "";
})(POSITIONS_WEIYUN || (POSITIONS_WEIYUN = {}));
/**
 * 生成 aid 的函数，必要的参数为触发位置和功能，系统和平台默认添加
 */
export function getWeiYunAidForReport(aidOptions) {
    systemCache = systemCache !== null && systemCache !== void 0 ? systemCache : getSystem();
    platformCache = platformCache !== null && platformCache !== void 0 ? platformCache : getPlatform();
    var position = aidOptions.position, feature = aidOptions.feature, apprec1 = aidOptions.apprec1, apprec2 = aidOptions.apprec2, apprec3 = aidOptions.apprec3;
    if (!verifyAidOptions(aidOptions)) {
        console.error('aid options 参数值校验失败，拒绝生成微云aid');
        return '';
    }
    var apprecString = joinApprecString([apprec1, apprec2, apprec3]);
    return systemCache + "_" + platformCache + "_" + position + "_" + feature + apprecString;
}
// ----------
// const CommonPositions = {
//   ...POSITIONS,
//   ...POSITIONS_WEIYUN,
// };
